import { type WorkoutItemGroupType } from "api-client/legacy-trpc";

import { type GroupWorkoutItemData } from "src/workouts/WorkoutEditStore";

import { InstructionsField } from "./InstructionsField";
import { RoundsField } from "./RoundsField";
import { SectionFieldsContainer } from "./SectionFieldsContainer";
import { SectionTypeField } from "./SectionTypeField";

interface TimedSectionFieldsProps {
  workoutItem: GroupWorkoutItemData;
  onUpdate: (updates: Partial<GroupWorkoutItemData>) => void;
}

export function TimedSectionFields(props: TimedSectionFieldsProps) {
  function handleStopPropagation(e: React.MouseEvent) {
    e.stopPropagation();
  }

  return (
    <SectionFieldsContainer onClick={handleStopPropagation}>
      <div className="flex justify-between gap-3">
        <SectionTypeField
          value={props.workoutItem.groupType}
          onChange={(value: WorkoutItemGroupType) => {
            props.onUpdate({ groupType: value });
          }}
        />
        <RoundsField
          value={props.workoutItem.rounds}
          onChange={(value) => {
            props.onUpdate({ rounds: value });
          }}
        />
      </div>
      <InstructionsField
        value={props.workoutItem.instructions}
        onChange={(value) => {
          props.onUpdate({ instructions: value });
        }}
      />
    </SectionFieldsContainer>
  );
}
